import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import shortid from "shortid";
export default function Placeholder() {
  const element = document.querySelector("#capture");
  domtoimage.toPng(element).then(function (dataUrl) {
    saveAs(dataUrl, `receipt-${shortid.generate()}.png`);
  });
}
